import { Validation } from "constants/Validation";
import * as Yup from "yup";
import { msgTypes } from "constants/msgTypes";

const MembershipFormSchema = [

    Yup.object().shape({
        companyName: Yup.string().required(Validation.required.message.replaceAll("^", "Company Name"))
            .matches(Validation.plaintext.regex, Validation.plaintext.message),
        companyEmail: Yup.string().required(Validation.required.message.replaceAll("^", "Company Email"))
            .matches(Validation.email.regex, Validation.email.message),
        primaryPhoneNumber: Yup.string().required(Validation.required.message.replaceAll("^", "Phone Number"))
            .matches(Validation.mobile.regex, Validation.mobile.message),
        // .min(10,Validation.minlength.message.replaceAll("^",10))
        // .max(15,Validation.maxlength.message.replaceAll("^",15)),
        secondaryPhoneNumber: Yup.string()
            .matches(Validation.mobile.regex, Validation.mobile.message),
        // .min(10,Validation.minlength.message.replaceAll("^",10))
        // .max(15,Validation.maxlength.message.replaceAll("^",15)),
        websiteUrl: Yup.string().matches(Validation.website.regex, Validation.website.message),
        accountingEmail: Yup.string().matches(Validation.email.regex, Validation.email.message),
        companyLogoFile: Yup.mixed().nullable()//.required(Validation.required.message.replaceAll("^","Image"))
            .test(
                "FILE_FORMAT",
                msgTypes.IMAGE_UNSUPPORTED_FORMAT,
                (value) => !value || (value && [msgTypes.IMAGE_FORMAT.JPEG, msgTypes.IMAGE_FORMAT.JPG, msgTypes.IMAGE_FORMAT.PNG, msgTypes.IMAGE_FORMAT.SVG
                ].includes(value?.type))
            )
            .test(
                "FILE_SIZE",
                msgTypes.FILE_SIZE_MESSAGE_1MB,
                (value) => !value || (value && value.size <= msgTypes.FILE_SIZE_1MB)
            ),

    }),
    Yup.object().shape({
        addressLine1: Yup.string().matches(Validation.plaintext.regex, Validation.plaintext.message),
        addressLine2: Yup.string().matches(Validation.plaintext.regex, Validation.plaintext.message),
        // cityId: Yup.string(),
        // stateId: Yup.string(),
        countryId: Yup.string().required(Validation.required.message.replaceAll("^", "Country")),
        zipCode: Yup.string().required(Validation.required.message.replaceAll("^", "Zip Code"))
            .matches(Validation.zipCode.regex, Validation.zipCode.message),
    }),
    Yup.object().shape({
        // companyDetails: Yup.string().required(Validation.required.message.replaceAll("^","Company Description"))
        //                 .matches(Validation.plaintext.regex , Validation.plaintext.message),
        companyDetails: Yup.string()
            .test("is-quill-empty", "Company Details is required", (value) => {
                const plainText = value?.replace(/<(.|\n)*?>/g, '').trim();
                return plainText !== '';
            })

    }),
    Yup.object().shape({
        instagramUrl: Yup.string().matches(Validation.website.regex, Validation.website.message),
        linkedinUrl: Yup.string().matches(Validation.website.regex, Validation.website.message),
        twitterUrl: Yup.string().matches(Validation.website.regex, Validation.website.message),
        facebookUrl: Yup.string().matches(Validation.website.regex, Validation.website.message),
        youtubeUrl: Yup.string().matches(Validation.website.regex, Validation.website.message)
    }),
    Yup.object().shape({
        membershipType: Yup.string().required(Validation.required.message.replaceAll("^", "Membership Type")),
    }),
    Yup.object().shape({
        contactPerson: Yup.array(),
    }),
];

export default MembershipFormSchema;